<template>
  <div class="content">

    <h1> 각종 주요 변수 </h1>

    <h2> 모바일여부 (단말기 정보) </h2>
    <div>
      $device.isMobile = {{ $device.isMobile }}
      <button @click="toggle('device')">기타 다른 변수들 보기</button>
      <xmp v-if="show.device"> $device = {{ $device }} </xmp>
    </div>

    <h2> 모바일여부 (@media 태그기능) </h2>
    <div>
      $mq = {{ $mq }}
      <div>
        screen 이 640 이하인경우 'mobile' 그 이상은 'desktop'
      </div>
    </div>

    <h2>세션 (로그인관련정보)</h2>

<table class="tbl01">
<tr><th> 항목 </th><th> 사용법</th></tr>
<tr><th nowrap="nowrap"> 로그인여부</th><td>$store.getters["session/isLogin"] = {{ this.$store.getters["session/isLogin"] }}</td></tr>
<tr><th> 전체 </th><td> $store.state.session.user = {{ $store.state.session.user }} </td></tr>
<tr><th> 이름 </th><td> $store.state.session.user.name = {{ $store.state.session.user.name }} </td></tr>
<tr><th> 이름(번호) </th><td> $store.getters['session/userDpName'] = {{ $store.getters['session/userDpName'] }} </td></tr>
<tr><th> 타입 </th><td> $store.state.session.user.type = {{ $store.state.session.user.type }} </td></tr>
<tr><th> type 의미 </th><td> "self" = 개인변호사, "member" = 법인소속 변호사, "master" = 법인 마스터 계정 </td></tr>
</table>


  </div>
</template>

<style scoped>
h2 { margin-top: 20px; }
div.content { line-height: 25px; }
.tbl01 td { text-align:  left; }
</style>

<script>
export default {
  data() {
    return {
      show: {  },
      // show: { device : false, },
    }
  },
  methods: {
    toggle(name) {
      this.show = T.toggle(this.show, name)
    }
  },
}
</script>